/**
 * ca_preview only: hand-picked region photography, shipped from public/images
 * (no third-party fetch, so it lands with the page). Chosen from Wikimedia
 * Commons quality images for light and composition, to sit beside the
 * store's own art-directed imagery. Regions not listed keep their stored
 * photo. Both licences require credit, which the pages show.
 */
import { withBase } from './brand';

export interface CuratedPhoto {
  src: string;
  /** What the picture shows, for alt text. */
  alt: string;
  credit: string;
  /** CSS object-position for crops. */
  focus?: string;
}

const PHOTOS: Record<string, CuratedPhoto> = {
  grampians: {
    src: '/images/ca-region-grampians.jpg',
    alt: 'The Grampians from the Pinnacle lookout, Halls Gap and Lake Bellfield below',
    credit: 'Photo: DXR, CC BY-SA 4.0, via Wikimedia Commons',
    focus: '50% 55%',
  },
  'flinders ranges': {
    src: '/images/ca-region-flinders.jpg',
    alt: 'Wilpena Pound at sunset from the Moralana Scenic Drive, Flinders Ranges',
    credit: 'Photo: Faj2323, CC BY-SA 4.0, via Wikimedia Commons',
    focus: '45% 50%',
  },
};

export function curatedRegionPhoto(name?: string | null): CuratedPhoto | null {
  const p = PHOTOS[(name || '').trim().toLowerCase()];
  return p ? { ...p, src: withBase(p.src) } : null;
}
